type SectionForDirtyCheck = {
  sectionId: string
  parentSectionId?: string | null
  title: string
  kind: string
  sortOrder: number
  markdown: string
}

export function serializeComplianceDocumentSectionsForDirtyCheck(
  sections: SectionForDirtyCheck[]
): string {
  const normalized = [...sections]
    .sort((left, right) => left.sortOrder - right.sortOrder)
    .map((section) => ({
      sectionId: section.sectionId,
      parentSectionId: section.parentSectionId ?? null,
      title: section.title,
      kind: section.kind,
      sortOrder: section.sortOrder,
      markdown: section.markdown,
    }))
  return JSON.stringify(normalized)
}
